import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { GetDonation } from "./DonationContextProvider";

function ReceiptLeftSection() {
  const styles = StyleSheet.create({
    textStyle: {
      transform: "rotate(90deg)",
      fontSize: "1vw",
    },
    viewStyle: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  });
  const donation = GetDonation();
  return (
    <>
      <View style={styles.viewStyle}>
        <Text style={styles.textStyle}>{donation.id}</Text>
      </View>
    </>
  );
}

export default ReceiptLeftSection;
